var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _vm.formInfo.types !== 3
        ? _c(
            "div",
            { staticClass: "btn-box mb10" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addContract },
                },
                [_vm._v("添加合同")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.contractData, fit: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "contract_name",
              label: _vm.$t("customer.contractname"),
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "contract_price",
              "min-width": "100px",
              label: _vm.$t("customer.contractpay"),
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "surplus", label: "付款状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    parseFloat(scope.row.surplus) === 0
                      ? _c("span", { staticClass: "pointer color-success" }, [
                          _vm._v("已结清"),
                        ])
                      : _c("span", { staticClass: "pointer color-warning" }, [
                          _vm._v("未结清"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "contract_status", label: "合同状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.getAbnormalTag(scope.row) } },
                      [_vm._v(_vm._s(_vm.getAbnormalTexts(scope.row)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "creator.name", label: "创建人" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "address", label: _vm.$t("public.operation") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCheck(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.check")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.where.page,
              layout: "total, prev, pager, next, jumper",
              total: _vm.contractTotal,
            },
            on: { "current-change": _vm.pageChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("editContract", {
        ref: "editContract",
        attrs: { "form-data": _vm.fromData },
        on: { isOk: _vm.getTableData },
      }),
      _vm._v(" "),
      _c("add-contract", {
        ref: "addContract",
        attrs: { "form-data": _vm.contractFromData },
        on: {
          getTableData: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }